import { useState, useEffect, useRef } from "react";

import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
const ProtectRoute = ({ children }) => {
	const { authenticate } = useSelector((state) => state.auth);

	const windowId = useRef(null);
	const [isMain, setIsMain] = useState(true);

	const compareTabID = () => {
		let sessionTabID = sessionStorage.getItem("tabId");
		let localTabID = localStorage.getItem("tabId");
		if (!localTabID) {
			localStorage.setItem("tabId", sessionTabID);
		}
		return localTabID === sessionTabID;
	};

	const getLocalTabID = () => {
		let storage = window.localStorage.getItem("tabId");
		return storage ? storage : null;
	};

	const setWindowArray = (data) => {
		if (!data) {
			window.localStorage.removeItem("tabId");
		} else window.localStorage.setItem("tabId", data);
	};

	const determineWindowState = () => {
		let windowArray = getLocalTabID();
		if (!windowArray) {
			setIsMain(true);
			setWindowArray(
				windowId.current ? windowId.current : sessionStorage.getItem("tabId")
			);
		} else {
			setIsMain(false);
		}
	};

	const removeWindow = () => {
		setWindowArray();
	};

	useEffect(() => {
		if (!authenticate) return;
		window.addEventListener("beforeunload", removeWindow);
		window.addEventListener("unload", removeWindow);
		if (windowId.current) removeWindow();
		windowId.current = localStorage.getItem("tabId");
		determineWindowState();

		return () => {
			window.removeEventListener("beforeunload", removeWindow);
			window.removeEventListener("unload", removeWindow);
		};
	}, []);

	return authenticate ? (
		isMain || compareTabID() ? (
			children
		) : (
			<Navigate to="/error" />
		)
	) : (
		<Navigate to="/login" />
	);
};
export default ProtectRoute;
